import { useEffect, useState } from "react";
import Head from "next/head";
import Header from "../components/Header";
import Link from "next/link";
import Srcset from "../components/common/Srcset";
import styles from "../components/ErrorsComp/ErrorComp.module.scss";
import { viewNotFound } from "@/components/common/Nosto";
import { builderClient } from "@/utils/builder";
import { BuilderComponent, useIsPreviewing } from "@builder.io/react";
import { useRouter } from "next/compat/router";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setMenuData } from "@/redux/actions/generalAction";
import { getMenu } from "@/utils/getSeoMenu";

//OS-3066 : added to check if css issue gets fixed
export const getStaticProps = async () => {
  return {
    props: { menuElement : await getMenu("/") },
    revalidate: 60,
  };
};

const ErrorComponent = (props) => {
  const { errorStatus = 500 } = props;

  const dispatch = useDispatch();
  if (props.menuElement) {
    dispatch(setMenuData(JSON.stringify(props.menuElement)));
  }

  let dsnLink =
    "https://" + process.env.ALGOLIA_APPLICATION_ID + "-dsn.algolia.net";
  let gtagLink =
    "https://www.googletagmanager.com/gtag/js?id=" + process.env.GTAG_KEY;
    let klaviyoSRC = "//static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + process.env.KLAVIYO_KEY

  const router = useRouter();
  const [builderContentJson, setBuilderContentJson] = useState(null);
  const isPreviewing = useIsPreviewing();
  const nostoPlacements = useSelector((state) => state.nosto.nostoPlacements);
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  let rakutenSRC = "https://tag.rmp.rakuten.com/" + process.env.RAKUTEN_KEY + ".ct.js";
  useEffect(() => {
    viewNotFound();
    builderClient
      .get("page", {
        userAttributes: {
          urlPath: router.asPath.split("?")[0],
        },
        options: { includeUnpublished: true },
      })
      .promise()
      .then(setBuilderContentJson);
    if (!builderContentJson && !isPreviewing) viewNotFound();
  }, []);

  var newrelicFile = ''
  if (process.env.APP_MODE == 'production') {
    newrelicFile = '/js/newrelic.js';
  } else if (process.env.APP_MODE == 'stage') {
    newrelicFile = '/js/newrelic_stage.js';
  }

  return (
    <>
      <Head>
        <title>Page Not Found | Olivela</title>
        <link crossOrigin href={dsnLink} rel="preconnect" />
        {/* <script async src={gtagLink}></script> */}

        {/* error reporting script */}
        <script async type="text/javascript" src={newrelicFile} />

        {/* <!-- AnalyticsJS - Segment.com --> */}
        {/* <script
          dangerouslySetInnerHTML={{
            __html: `
!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
analytics.load("1MTr5E0mmf92XtjsOhAmPWHq6D8aHBGC");
analytics.page();
}}()`,
          }}
        /> */}
        {/* <!-- SETUP FOR klaviyo start --> */}
        <script
          async
          type="text/javascript"
          src={klaviyoSRC}
        ></script>
        {/* <!-- SETUP FOR klaviyo end --> */}

        {/* <!-- Google Tag Manager --> */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.GTM_KEY}');
    `,
          }}
        ></script>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        {process.env.APP_MODE == 'production' && <script
          async
          type="text/javascript"
          src={rakutenSRC}></script>}
          {/*  Start of VWO Async SmartCode */}
          <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
        <script id = "vwoCode" strategy="beforeInteractive"
          dangerouslySetInnerHTML={{
            __html: `
           
            window._vwo_code || (function() {
            var account_id=${process.env.VWO_ACC_ID},
            version=2.0,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            /* DO NOT EDIT BELOW THIS LINE */
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){w._vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();(function(){var i=window;function t(){if(i._vwo_code){var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){if(!document.getElementById('_vis_opt_path_hides')){document.getElementsByTagName('head')[0].appendChild(e)}requestAnimationFrame(t)}}}t()})();
            
            `,
            }}
        ></script>
        {/*  End VWO Async SmartCode */}
      </Head>
     
      {isPreviewing || builderContentJson ? (
        <BuilderComponent model="page" content={builderContentJson} />
      ) : 
      (<>
      <div className={`container mw-1440 ${styles.error_comp}`}>

        <h2 className={`${styles.error_header}`}>Apologies</h2>
        <p className={`small-xs small-sm large-md ${styles.error_message}`}>
          {`The page you are looking for is no longer available, but we trust we have something else that may interest you.`}
        </p>
        <div className={`pwa-link-tag ${styles.button_wrap}`}>
          <Link href="/new-arrivals" className={`btn-secondary-inverted ${styles.error_cta}`}>
              <span className="normal-sm normal-md x-small-xs">{`Shop new in`}</span>
              <Srcset
                svgFile={true}
                requirePath={true}
                alt="right-arrow"
                height="10"
                width="12"
                src={"images/Icons/Arrow/Right/Large_dark.svg"}
              />
          </Link>
        </div>
      </div>
      <div
        className="nosto_element"
        id="notfound-nosto-2"
        dangerouslySetInnerHTML={{
          __html: nostoPlacements["notfound-nosto-2"]
            ? nostoPlacements["notfound-nosto-2"]
            : "",
        }}
      ></div>
      </>)}
    </>
  );
};

export default ErrorComponent;


